import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

const COMPONENTS: any[] = [
];

@NgModule({
  imports: [
    CommonModule,
    ModalModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})

export class RootSharedModule { }
